import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import PageLoading from "@/components/base/PageLoading";

const Home = lazy(() => import("@/pages/home/page"));
const Services = lazy(() => import("@/pages/services/page"));
const Careers = lazy(() => import("@/pages/careers/page"));
const Projects = lazy(() => import("@/pages/projects/page"));
const About = lazy(() => import("@/pages/about/page"));
const Blog = lazy(() => import("@/pages/blog/page"));
const BlogDetail = lazy(() => import("@/pages/blog/detail"));
const Calculator = lazy(() => import("@/pages/calculator/page"));
const Resources = lazy(() => import("@/pages/resources/page"));
const Checklist = lazy(() => import("@/pages/resources/checklist/page"));
const Brochure = lazy(() => import("@/pages/brochure/page"));
const Questionnaire = lazy(() => import("@/pages/questionnaire/page"));
const PrivacyPolicy = lazy(() => import("@/pages/legal/PrivacyPolicy"));
const Contact = lazy(() => import("@/pages/contact/page"));
const ConstructionManagementPage = lazy(() => import("@/pages/seo/ConstructionManagementPage"));
const HeavyMachineryRentalPage = lazy(() => import("@/pages/seo/HeavyMachineryRentalPage"));
const MaintenanceServicesPage = lazy(() => import("@/pages/seo/MaintenanceServicesPage"));
const ResidentialConstructionPage = lazy(() => import("@/pages/seo/ResidentialConstructionPage"));
const CommercialConstructionPage = lazy(() => import("@/pages/seo/CommercialConstructionPage"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function LazyWrapper({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
}

const routes: RouteObject[] = [
  { path: "/", element: <LazyWrapper><Home /></LazyWrapper> },
  { path: "/services", element: <LazyWrapper><Services /></LazyWrapper> },
  { path: "/construction-management", element: <LazyWrapper><ConstructionManagementPage /></LazyWrapper> },
  { path: "/heavy-machinery-rental", element: <LazyWrapper><HeavyMachineryRentalPage /></LazyWrapper> },
  { path: "/maintenance-services", element: <LazyWrapper><MaintenanceServicesPage /></LazyWrapper> },
  { path: "/residential-construction", element: <LazyWrapper><ResidentialConstructionPage /></LazyWrapper> },
  { path: "/commercial-construction", element: <LazyWrapper><CommercialConstructionPage /></LazyWrapper> },
  { path: "/careers", element: <LazyWrapper><Careers /></LazyWrapper> },
  { path: "/projects", element: <LazyWrapper><Projects /></LazyWrapper> },
  { path: "/calculator", element: <LazyWrapper><Calculator /></LazyWrapper> },
  { path: "/resources", element: <LazyWrapper><Resources /></LazyWrapper> },
  { path: "/resources/checklist", element: <LazyWrapper><Checklist /></LazyWrapper> },
  { path: "/about", element: <LazyWrapper><About /></LazyWrapper> },
  { path: "/contact", element: <LazyWrapper><Contact /></LazyWrapper> },
  { path: "/privacy-policy", element: <LazyWrapper><PrivacyPolicy /></LazyWrapper> },
  { path: "/brochure", element: <LazyWrapper><Brochure /></LazyWrapper> },
  { path: "/questionnaire", element: <LazyWrapper><Questionnaire /></LazyWrapper> },
  { path: "/get-started", element: <LazyWrapper><Questionnaire /></LazyWrapper> },
  { path: "/blog", element: <LazyWrapper><Blog /></LazyWrapper> },
  { path: "/blog/:slug", element: <LazyWrapper><BlogDetail /></LazyWrapper> },
  { path: "*", element: <LazyWrapper><NotFound /></LazyWrapper> },
];

export default routes;